module.exports = __webpack_public_path__ + "img/business-man-headset.aed3fc68.png";